import React from 'react';
import {Box} from '../box';
import {VisibilityBox} from '../box/visibility-box';
import {FrameworkImage} from '../image-renderer';
import {Typography} from '../typography';

export interface WrapTextWithImageProps {
  bodyText1?: string | null;
  bodyText2?: string | null;
  bodyText3?: string | null;
  image?: string | null;
  imageAlt?: string | null;
  havePaddingTop?: boolean;
  isStudioPage?: boolean;
}

export const WrapTextWithImage: React.FC<WrapTextWithImageProps> = ({
  bodyText1,
  bodyText2,
  bodyText3,
  image,
  imageAlt,
  havePaddingTop = true,
  isStudioPage = false,
}: WrapTextWithImageProps) => {
  const bodyImg = image ? (
    <Box
      height={
        isStudioPage
          ? ['510px', '400px']
          : ['510px', '388px', '486px', '596px', '784px']
      }
      width={['100%', '270px', '350px', '446px', '600px']}
      css={{float: 'right'}}
      marginX={['zero', 'twelve']}
      marginY={['zero', 'eight']}
    >
      <FrameworkImage
        src={image}
        layout="fill"
        objectFit="cover"
        alt={imageAlt || ''}
        style={isStudioPage ? {borderRadius: '16px'} : {}}
      />
    </Box>
  ) : null;

  return (
    <Box pt={havePaddingTop ? 'fifteen' : 'four'}>
      <VisibilityBox show={[true, false]}>
        <Box marginX="md">
          <Typography color="textDefault" textStyle={['h3']}>
            {bodyText1}
          </Typography>
        </Box>
        <Box marginY="eight">{bodyImg}</Box>
        <Box marginX="md">
          <Typography color="textDefault" textStyle={['h3']}>
            {bodyText2}
          </Typography>
          {bodyText3 ? (
            <>
              <br />
              <Typography color="textDefault" textStyle={['h3']}>
                {bodyText3}
              </Typography>
            </>
          ) : null}
        </Box>
      </VisibilityBox>
      <VisibilityBox show={[false, true]}>
        {isStudioPage ? (
          <Box flexDirection="row">
            <Box flex={1}>
              <Typography color="textDefault" textStyle={['h2', 'h2', 'h1']}>
                {bodyText1}
              </Typography>

              <Typography color="textDefault" textStyle={['h2', 'h2', 'h1']}>
                {bodyText2}
              </Typography>
              {bodyText3 && (
                <Typography color="textDefault" textStyle={['h2', 'h2', 'h1']}>
                  {bodyText3}
                </Typography>
              )}
            </Box>
            <Box flex={2}>{bodyImg}</Box>
          </Box>
        ) : (
          <Box marginX="lg">
            <div>
              <Typography color="textDefault" textStyle={['h2', 'h2', 'h1']}>
                {bodyText1}
              </Typography>
              {bodyImg}
              <Typography color="textDefault" textStyle={['h2', 'h2', 'h1']}>
                {bodyText2}
              </Typography>
              {bodyText3 ? (
                <>
                  <br /> <br />
                  <Typography
                    color="textDefault"
                    textStyle={['h2', 'h2', 'h1']}
                  >
                    {bodyText3}
                  </Typography>
                </>
              ) : null}
            </div>
          </Box>
        )}
      </VisibilityBox>
    </Box>
  );
};
